import React from 'react';

import TimelineWidget from './TimelineWidget.js';
import TabWidget from './TabWidget.js';
import TemporalWidget from './TemporalWidget.js';
import FilterWidget from './FilterWidget.js';
import ShareWidget from './ShareWidget.js';
import {randomChoice} from './utils.js';

import './ControlWidget.css';

class ControlWidget extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            'tab_selected': 'Temporal',

            'width': window.innerWidth,
        };

        this.changeTab = this.changeTab.bind(this);

        const temp_examples = {
            'April 26, 1991': ['state = Kansas', 'path-length > 20'],
            'Apr 11 1965': ['state = Ohio', 'path-length >= 50'],
            '4/27/2011': ['state = MS', 'path-length >= 50', 'fatalities > 20'],
            '5/3/99': ['state = OK', 'injuries > 10'],
            'May 4-11 2003': ['state = Illinois', 'path-width < 400'],
            'Jun 16-18, 2014': ['state = NE', 'path-width >= 400'],
            '1974': ['region = southeast', 'injuries > 20'],
            '1957': ['region = plains', 'fatalities >= 10'],
            'May 2019': ['region = midwest', 'path-length < 3'],
            'Nov 2013': ['state = IN', 'injuries >= 10']
        };


        this.temp_example = randomChoice(Object.keys(temp_examples));

        const filt_examples = temp_examples[this.temp_example];
        this.filt_example = randomChoice(filt_examples);
    }

    componentDidMount() {
        window.addEventListener('resize', this.windowResize.bind(this));
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.windowResize.bind(this));
    }

    windowResize() {
        this.setState({'width': window.innerWidth});
    }

    changeTab(new_tab) {
        this.setState({'tab_selected': new_tab});
    }

    render() {
        const margin_left = 40;
        const margin_right = 55;

        const tabs = [
            {'name': 'Temporal', 'jsx':
                <TemporalWidget
                    interval={this.props['interval']}
                    example={this.temp_example}
                    onintervalchange={this.props['onintervalchange']}
                    data_limits={this.props['data_limits']}
                />
            },
            {'name': 'Filters', 'jsx':
                <FilterWidget
                    width={this.state['width']}
                    example={this.filt_example}
                    partitioner={this.props['partitioner']}
                    filters={this.props['filters']}

                    onpartselectchange={this.props['onpartselectchange']}
                    onfilterchange={this.props['onfilterchange']}
                />
            },
            {'name': 'Share', 'jsx':
                <ShareWidget
                    onscreenshot={this.props['onscreenshot']}
                />
            }
        ];

        return (    
            <div id='controls'>
                <TabWidget
                    tabs={tabs.map(t => t['name'])}
                    selected={this.state['tab_selected']}
                    ontabchange={this.changeTab}
                />
                <div id='control-container'>
                    {tabs.filter(t => t['name'] == this.state['tab_selected'])[0]['jsx']}
                </div>
                <TimelineWidget 
                    interval={this.props['interval']}
                    tor_coll={this.props['tor_coll']}
                    partitioner={this.props['partitioner']}
                    part_select={this.props['part_select']}
                    
                    width={this.state['width']}
                    height={150}
                    margins={{'top': 5, 'bottom': 30, 'left': margin_left, 'right': margin_right}}
                    tbounds={this.props['timeline_tbnds']}
                    timeline_limits={this.props['timeline_limits']}

                    onintervalchange={this.props['onintervalchange']}
                    ontboundschange={this.props['ontboundschange']}

                    setscreenshotfunc={this.props['setscreenshotfunc']}
                />
            </div>
        );
    }
}

export default ControlWidget;
